import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/assets/css/corporate.css';
import App from './App';

import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
      <App />
  </QueryClientProvider> 
);

// To measure performance in this app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//
//reportWebVitals(console.log);
